import React, { useRef, useState } from "react";
import AppContainer from "../../../components/AppContainer";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { Box, Chip, Grid, MenuItem, Stack, Typography } from "@mui/material";
import CusomCheckBox from "../../../components/CustomCheckbox";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import CustomDropDown from "../../../components/CutomDropDown";
import GlobalButton from "../../../components/CustomButton";
import AddIcon from "@mui/icons-material/Add";
import CreateStudentRequestDialog from "./StudentCreateReqDialog";

const allClasses = [
  "1st class",
  "2nd class",
  "3rd class",
  "4th class",
  "5th class",
  "6th class",
  "7th class",
  "8th class",
  "9th class",
  "10th classs",
];

const allGrades = ["A+1", "A", "B", "C", "D", "E"];
const feeType = ["Installment 1", "Installment 2", "Installment 3"];

const AddEditAdmissionStep2 = () => {
  const openReqDialog = useRef(null);
  const dispatch = useDispatch();
  const uploadTranscriptRef = useRef(null);
  const [isReqPreviousDetail, setIsReqPreviousDetail] = useState(true);
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  return (
    <>
      <AppContainer
        primaryHeading={"Add New Admission"}
        secondaryHeading={"Step 2"}
        showBackButton={true}
        handleBack={() =>
          dispatch(
            setActiveTab({
              ...activeTab,
              education_admission: "ed_add_admissions_step1",
            })
          )
        }
      >
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <CusomCheckBox
            isChecked={isReqPreviousDetail}
            handleChecked={() => {
              setIsReqPreviousDetail((prev) => !prev);
            }}
          />
          <Typography variant="h6" fontWeight={500}>
            Previous School Details
          </Typography>
        </Stack>

        <Grid container my={1.5} spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Label
              labelText="Previous class"
              required
              htmlFor={"std_previous_class"}
            />
            <CustomDropDown>
              {allClasses.map((val, ind) => {
                return <MenuItem key={ind}>{val}</MenuItem>;
              })}
            </CustomDropDown>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Label
              labelText="Previous school name"
              required
              htmlFor={"std_previous_school_name"}
            />
            <TextInput
              id={"std_previous_school_name"}
              required
              styleProps={globalStyle.textField}
              placeholder={"Enter previous school name"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Label
              labelText="Last class grade"
              required
              htmlFor={"std_last_grade"}
            />
            <CustomDropDown>
              {allGrades.map((val, ind) => {
                return <MenuItem key={ind}>{val}</MenuItem>;
              })}
            </CustomDropDown>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Label labelText="Attendance" required htmlFor={"std_attendance"} />
            <TextInput
              id={"std_attendance"}
              required
              styleProps={globalStyle.textField}
              placeholder={"Enter attendance"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Label
              labelText="Student repeated class"
              required
              htmlFor={"std_repeated_class"}
            />
            <CustomDropDown>
              <MenuItem value={"Yes"}>Yes</MenuItem>
              <MenuItem value={"No"}>No</MenuItem>
            </CustomDropDown>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Label
              labelText="Class Name"
              required
              htmlFor={"std_repeated_class_name"}
            />
            <CustomDropDown>
              {allClasses.map((val, ind) => {
                return <MenuItem key={ind}>{val}</MenuItem>;
              })}
            </CustomDropDown>
          </Grid>
          <Grid item xs={12}>
            <Label
              labelText="Reason leaving previous school"
              required
              htmlFor={"std_leave_reason"}
            />
            <TextInput
              id={"std_leave_reason"}
              required
              multiline
              rows={3}
              styleProps={globalStyle.textField}
              placeholder={"Enter attendance"}
            />
          </Grid>
        </Grid>
        <Typography variant="h6" fontWeight={500}>
          Current Admission
        </Typography>

        <Grid container my={1.5} spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Label labelText="Class" required htmlFor={"std_current_class"} />
            <CustomDropDown>
              {allClasses.map((val, ind) => {
                return <MenuItem key={ind}>{val}</MenuItem>;
              })}
            </CustomDropDown>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Label labelText="Fee Type" required htmlFor={"std_fee_type"} />
            <CustomDropDown>
              {feeType.map((val, ind) => {
                return <MenuItem key={ind}>{val}</MenuItem>;
              })}
            </CustomDropDown>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Label labelText="Admission Fee" required htmlFor={"std_fees"} />
            <TextInput
              id={"std_fees"}
              required
              styleProps={globalStyle.textField}
              placeholder={"E.g ; 800 USD"}
              InputEndIcon={
                <Typography variant="body1" color={"primary.main"}>
                  Fixed
                </Typography>
              }
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Label
              labelText="Tuition Fee"
              required
              htmlFor={"std_tuition_fees"}
            />
            <TextInput
              id={"std_tuition_fees"}
              required
              styleProps={globalStyle.textField}
              placeholder={"E.g ; 250 USD"}
              InputEndIcon={
                <Typography variant="body1" color={"primary.main"}>
                  Fixed
                </Typography>
              }
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Label
              labelText="Annual Fee"
              required
              htmlFor={"std_annual_fees"}
            />
            <TextInput
              id={"std_annual_fees"}
              required
              styleProps={globalStyle.textField}
              placeholder={"E.g ; 1000 USD"}
              InputEndIcon={
                <Typography variant="body1" color={"primary.main"}>
                  Fixed
                </Typography>
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.5}>
            <Label labelText="Discount%" required htmlFor={"std_discount"} />
            <TextInput
              id={"std_discount"}
              required
              styleProps={globalStyle.textField}
              placeholder={"Enter discount"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={1.5}>
            <Label labelText="Sub-Total" required htmlFor={"std_discount"} />
            <TextInput
              id={"std_discount"}
              required
              styleProps={globalStyle.textField}
              placeholder={"Enter discount"}
            />
          </Grid>
        </Grid>

        <Box>
          <Typography variant="h6" fontWeight={500} lineHeight={"normal"}>
            Documents Attachments
          </Typography>
          <Typography
            variant="body1"
            color={"custom.slateGrey"}
            lineHeight={"normal"}
          >
            Previuos school, college, Uni Records
          </Typography>
        </Box>

        <Grid container my={1.5} spacing={2} alignItems={"baseline"}>
          <Grid item xs={12} sm={3}>
            <GlobalButton
              startIcon={<AddIcon />}
              btnText={"Upload Transcripts"}
              handleClickBtn={() => uploadTranscriptRef.current.click()}
              styleProps={{
                height: 45,
              }}
            />
            <input
              ref={uploadTranscriptRef}
              type="file"
              style={{ display: "none" }}
            />
          </Grid>
          <Grid xs={12} sm={9}>
            <Stack ml={2} direction={"row"} alignItems={"center"} gap={1}>
              <Chip
                label="view file 1"
                color={"primary"}
                onDelete={() => console.log("deleted")}
              />
              <Chip
                label="view file 1"
                color={"primary"}
                onDelete={() => console.log("deleted")}
              />
            </Stack>
          </Grid>
        </Grid>

        <Grid container my={1.5} spacing={2} alignItems={"baseline"}>
          <Grid item xs={12} sm={3}>
            <GlobalButton
              btnText={"Upload Birth Certificate"}
              handleClickBtn={() => uploadTranscriptRef.current.click()}
              styleProps={{
                height: 45,
              }}
            />
            <input
              ref={uploadTranscriptRef}
              type="file"
              style={{ display: "none" }}
            />
          </Grid>
          <Grid item xs={12} md={9}>
            <Stack direction={"row"} alignItems={"center"} gap={1}>
              <Chip
                label="view file"
                color={"primary"}
                onDelete={() => console.log("deleted")}
              />
            </Stack>
          </Grid>
        </Grid>
        <Grid container my={1.5} spacing={2} alignItems={"baseline"}>
          <Grid item xs={12} sm={4}>
            <GlobalButton
              btnText={"Upload Guardian Identification"}
              handleClickBtn={() => uploadTranscriptRef.current.click()}
              styleProps={{
                height: 45,
              }}
            />
            <input
              ref={uploadTranscriptRef}
              type="file"
              style={{ display: "none" }}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <Stack direction={"row"} alignItems={"center"} gap={1}>
              <Chip
                label="view file 1"
                color={"primary"}
                onDelete={() => console.log("deleted")}
              />
            </Stack>
          </Grid>
        </Grid>
        <Grid container my={1.5} spacing={2} alignItems={"baseline"}>
          <Grid item xs={12} sm={3}>
            <GlobalButton
              btnText={"Upload Address Proof"}
              handleClickBtn={() => uploadTranscriptRef.current.click()}
              styleProps={{
                height: 45,
              }}
            />
            <input
              ref={uploadTranscriptRef}
              type="file"
              style={{ display: "none" }}
            />
          </Grid>
          <Grid item xs={12} md={9}>
            <Stack direction={"row"} alignItems={"center"} gap={1}>
              <Chip
                label="view file 1"
                color={"primary"}
                onDelete={() => console.log("deleted")}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* Next to pay fee */}
        <Stack my={2} alignItems={"flex-end"}>
          <GlobalButton
            btnText={"Next to pay Fee"}
            handleClickBtn={() => openReqDialog.current.openDialog()}
            styleProps={{
              height: 45,
              width: 150,
            }}
          />
        </Stack>
      </AppContainer>
      <CreateStudentRequestDialog
        ref={openReqDialog}
        handleClick={() => {
          dispatch(
            setActiveTab({
              ...activeTab,
              education_admission: "ed_all_admissions",
            })
          );
        }}
      />
    </>
  );
};

export default AddEditAdmissionStep2;
